import { DataPath, ExprPath, } from '@mode-switch/express';
import { Compiler } from '../Compiler';
import { Pipeline } from '../Pipeline';
export var Attrs;
(function (Attrs) {
    function make(catalog, model, viewName, exprEnv) {
        return (pipeline, node) => {
            switch (node.type) {
                case "Identifier":
                case "AccessIdentifier":
                case "AccessExpression":
                    return vAccess(pipeline, catalog, model, viewName, exprEnv, node);
                default:
                    return pipeline;
            }
        };
    }
    Attrs.make = make;
    function vAccess(pipeline, catalog, model, viewName, exprEnv, node) {
        var _a;
        const path = Pipeline.Paths.get(pipeline, node);
        if (path == null) {
            throw new Error(`Cannot find access path for node ${node}`);
        }
        const param = catalog.getParam(model, path);
        if (param != null) {
            return Pipeline.Params.set(pipeline, node, param);
        }
        const attr = catalog.getViewAttr(model, viewName, path);
        if (attr != null) {
            switch (attr.source) {
                case "CALC": {
                    const { source } = attr.formula;
                    const { name } = attr;
                    let pipe = Pipeline.make();
                    {
                        const dataPath = ExprPath.fromParseNode(node);
                        if (dataPath.type === "NAMED") {
                            const name = DataPath.format(dataPath);
                            if (pipeline.parents.has(name)) {
                                const path = [...pipeline.parents].join(' → ') + ` → ${name}`;
                                throw new Error(`Field ${name} cannot refer to itself: ${path}`);
                            }
                            const parents = new Set(pipeline.parents);
                            parents.add(name);
                            pipe = {
                                ...pipe,
                                parents,
                            };
                        }
                    }
                    const result = Compiler.compile(catalog, pipe, model, viewName, source, exprEnv);
                    switch (result.type) {
                        case "SUCCESS":
                            const { expr, expr: { data }, } = result;
                            pipeline = Pipeline.DataTypes.set(pipeline, node, data.type);
                            pipeline = Pipeline.DataRoles.set(pipeline, node, data.role);
                            pipeline = Pipeline.ExprNodes.set(pipeline, node, result.node);
                            pipeline = Pipeline.ExprStages.set(pipeline, node, expr.stage);
                            return Pipeline.Calcs.set(pipeline, node, attr);
                        case "PARSE_FAILURE":
                        case "RESOLVE_FAILURE": {
                            const error = result.errors[0];
                            throw new Error((_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : `Cannot compile calculation because the formula for ${name} is broken`);
                        }
                    }
                    break;
                }
                case "NAMES":
                case "VALUES":
                case "COLUMN": {
                    return Pipeline.Columns.set(pipeline, node, attr);
                }
            }
        }
        throw new Error(`Cannot find column, calculation, or parameter at path ${DataPath.format(path)}`);
    }
    Attrs.vAccess = vAccess;
})(Attrs || (Attrs = {}));
